import { createSlice } from '@reduxjs/toolkit';
import { CustomerType } from '@repo/common';

// import { SLICE_BASE_NAME } from '../auth/constant';

export interface EventState {
  modalStatus?: boolean;
  modalContent?: string;
  modalData?: any;
  sheetStatus?: boolean;
  customerType?: CustomerType;
  selectedCustomer: string;
  discountOpen?: boolean;
}

const initialState: EventState = {
  modalStatus: false,
  modalContent: '',
  sheetStatus: false,
  customerType: CustomerType.WALKIN,
  selectedCustomer: '',
  modalData: null,
};

const eventSlice = createSlice({
  name: `event`,
  initialState,
  reducers: {
    openModal(state, action) {
      state.modalStatus = true;
      state.modalContent = action.payload.content;
      state.modalData = action.payload.data;
    },
    closeModal(state) {
      state.modalStatus = false;
    },
    changeSheet(state, ation) {
      state.sheetStatus = ation.payload;
    },
    changeCustomerType(state, action) {
      state.customerType = action.payload;
    },
    openDiscount(state, action) {
      state.discountOpen = action.payload;
    },
    selectedCustomer(state, action) {
      state.selectedCustomer = action.payload;
    },

    getModalData(state) {
      // state.modalData = action.payload;

      return state?.modalData;
    },
  },
});

export const {
  openModal,
  closeModal,
  changeSheet,
  changeCustomerType,
  openDiscount,
  selectedCustomer,
  getModalData,
} = eventSlice.actions;
eventSlice.actions;
export default eventSlice.reducer;
